import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import MuiSwitch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

const Switch = ({ checked, label, onChange, formLabelProps, ...rest }) => (
  <FormControlLabel
    label={label}
    control={
      <MuiSwitch
        checked={checked}
        onChange={onChange}
        inputProps={{ 'aria-label': label }}
        {...rest}
      />
    }
    {...formLabelProps}
  />
);

Switch.defaultProps = {
  formLabelProps: {},
};

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formLabelProps: PropTypes.object,
};

export default Switch;
